import Logo from "./../logo.png";
import { useState } from "react";
import { useGuard } from "../Guard";
import { authLogin } from "../repository/auth.repository";
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  Layout,
  Typography,
} from "antd";

interface LoginForm {
  readonly username: string;
  readonly password: string;
  readonly keepLoggedIn?: boolean;
}

function LoginPage() {
  const [form] = Form.useForm();
  const guard = useGuard();
  const [loading, setLoading] = useState(false);
  const [invalidCredentials, setInvalidCredentials] = useState(false);

  // Driven by Form `onFinish` so the required-field rules run first and pressing
  // Enter in any field submits (native form submit → onFinish).
  function onSignIn(values: LoginForm): void {
    setLoading(true);
    setInvalidCredentials(false);
    authLogin({ identifier: values.username, password: values.password })
      .then((user) => {
        // On success the guard signs in and the route redirects away (this unmounts).
        guard.signIn(user, !!values.keepLoggedIn);
      })
      .catch(() => {
        setInvalidCredentials(true);
        setLoading(false);
      });
  }

  return (
    <Layout
      className="flex flex-auto flex-col items-center justify-center overflow-y-auto p-6"
      style={{ minHeight: "100vh" }}
    >
      <div className="flex w-full max-w-sm flex-col items-center">
        <img
          className="mb-8 max-h-40 w-auto object-contain"
          src={Logo}
          alt="Wellbeing"
        />
        <Card className="w-full shadow-lg">
          <Typography.Title level={4} className="!mb-6 text-center">
            Sign in
          </Typography.Title>
          <Form
            form={form}
            name="login"
            layout="vertical"
            autoComplete="on"
            requiredMark={false}
            onFinish={onSignIn}
          >
            <Form.Item
              label="Username"
              name="username"
              rules={[{ required: true, message: "Username is required" }]}
            >
              <Input size="large" autoFocus disabled={loading} />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Password is required" }]}
            >
              <Input.Password size="large" disabled={loading} />
            </Form.Item>
            <Form.Item name="keepLoggedIn" valuePropName="checked" className="!mb-3">
              <Checkbox disabled={loading}>Keep me logged in</Checkbox>
            </Form.Item>
            {invalidCredentials && (
              <Form.Item className="!mb-3">
                <Alert type="error" showIcon message="Invalid credentials" />
              </Form.Item>
            )}
            <Form.Item className="!mb-0">
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={loading}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Layout>
  );
}

export default LoginPage;
